<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :actions="actions"
      ref="grid"
      navigationPath="HelpDeskRequestView"
      navigationField="displayID"
      :selectionEnabled="false"
      :onRowClicked="onRowClicked"
      :onCellPrepared="onCellPrepared"
      name="HelpDeskRequests"
    ></dx-grid>

    <v-dialog persistent v-model="newTicketDialog" max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline">New request</span>
        </v-card-title>
        <v-form ref="form" autocomplete="on">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-select
                  v-model="newTicket.priority"
                  :items="priorityOptions"
                  label="Priority"
                  ref="newTicketSelectedPriority"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  v-model="newTicket.category"
                  :items="[
                    'Telephone',
                    'Desktop / Laptop /Server',
                    'Printers / scanner / Fax',
                    'Software',
                    'Camera',
                  ]"
                  label="Category"
                  ref="newTicketCategory"
                ></v-select>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model="newTicket.subject"
                  label="Enter a brief title for your request"
                  ref="newTicketSubject"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-Textarea
                  v-model="newTicket.description"
                  label="Write a message"
                  outline
                  ref="newTicketDescription"
                ></v-Textarea>
              </v-flex>

              <v-flex xs12>
                <span>This information is optional but recommended:</span>
              </v-flex>
              <v-layout row>
                <v-icon>mdi-phone</v-icon>
                <v-flex xs12 sm4>
                  <v-text-field
                    v-model="newTicket.phone"
                    name="phone"
                    label="Phone number"
                    browser-autocomplete="tel"
                    type="tel"
                    hint="We'll use this to contact you about your ticket"
                    persistent-hint
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    v-model="newTicket.phoneMapped"
                    name="phoneMapped"
                    label="Phone number 2"
                    browser-autocomplete="tel"
                    type="tel"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm2>
                  <v-text-field
                    v-model="newTicket.ext"
                    label="Ext Number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm2>
                  <v-text-field
                    v-model="newTicket.room"
                    label="Room Number"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-flex v-if="newTicket.hasContactInfoChanged" xs12>
                <v-checkbox
                  v-model="newTicket.saveNewContactInfo"
                  label="Save my contact info changes for next time"
                  color="success"
                  hide-details
                  class="mt-1"
                ></v-checkbox>
                <span v-if="newTicket.saveNewContactInfo" class="body-2"
                  >A separate ticket will be issued, and we will update the
                  request details within it.</span
                >
              </v-flex>

              <v-flex xs12 sm8>
                <v-btn
                  small
                  class="ml-0 mt-0"
                  color="success"
                  :loading="uploading"
                  @click="pickFile()"
                  >Upload Files
                  <v-icon right small>mdi-cloud-upload</v-icon></v-btn
                >
                <input
                  type="file"
                  multiple
                  style="display: none"
                  ref="files"
                  @change="onFilePicked($event)"
                />
              </v-flex>

              <v-card
                v-for="(file, index) in fileUploadList"
                style="
                  border: 1px solid #4caf50;
                  border-radius: 5px;
                  margin-right: 10px;
                "
                class="pa-2 my-2"
              >
                <v-layout row justify-space-between style="width: 250px">
                  <div class="mt-0 ml-0 pt-1">
                    {{ truncateText(file.name, 18) }}
                  </div>
                  <v-btn
                    color="success"
                    class="my-0 mr-1"
                    small
                    @click="removeUploadImg(index)"
                  >
                    remove
                  </v-btn>
                </v-layout>
              </v-card>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3">
            <!-- <v-btn flat small v-if="!newTicket.showNotificationEmailField" color="success" @click="newTicket.showNotificationEmailField = true" > {{ "Add Additional Recipient" }} </v-btn> <v-btn flat small v-if="newTicket.showNotificationEmailField" color="red" @click=" (newTicket.showNotificationEmailField = false), (newTicket.notificationEmails = '') " > {{ "Remove" }} </v-btn> <v-flex v-if="newTicket.showNotificationEmailField"> <v-text-field v-model="newTicket.notificationEmails" label="To send a copy of the ticket to another email, Enter a valid email" type="Email" :rules="[rules.email]" ></v-text-field> </v-flex> -->
            <v-spacer></v-spacer>

            <v-btn
              small
              color="default"
              @click="reset"
              :dark="!cancelBtnAbility"
              :disabled="cancelBtnAbility"
              >Cancel</v-btn
            >
            <v-btn
              small
              :loading="processing"
              dark
              color="success"
              @click="saveNewTicket"
              :dark="!sendBtnDisability"
              :disabled="sendBtnDisability"
              >Send</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="unmappedUserDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Unable to Sent Ticket</v-card-title>
        <v-card-text>
          We're sorry, but your username
          {{ $store.state.authentication.user }} isnt connected to our ticketing
          system. <br />
          Please contact support at extension #12340 and provide your username:
          <strong>{{ $store.state.authentication.user }}</strong
          >. <br />
          or press Send and this will send a request to help desk.
          <v-text-field
            v-model="unmappedUserPhone"
            label="Please provide a phone number"
            class="mt-0"
            type="tel"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small dark color="default" @click="unmappedUserDialog = false"
            >Cancel</v-btn
          >
          <v-btn small color="success" dark @click="submitUnmappedUserTicket"
            >Send</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { truncate } from "../../utils/helpers.js";
import {
  statusIcon,
  statusIconColor,
  linkifyPlainUrlsInHtml,
  priorityOptions,
} from "./helpDeskHelpers.js";
export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data: () => ({
    cancelBtnAbility: false,
    sendBtnDisability: false,
    title: "Support Tickets",
    url: "",
    actions: [],
    newTicketDialog: false,
    processing: false,
    uploading: false,
    fileUploadList: [],
    includeClosed: false,
    filterForStatus: [],
    manageengineUserInfo: null,
    unmappedUserDialog: false,
    unmappedUserPhone: "",
    priorityOptions: priorityOptions,
    newTicket: {
      subject: "",
      description: "",
      category: "",
      priority: "Normal",
      phone: "",
      room: "",
      ext: "",
      phoneMapped: "",
      hasContactInfoChanged: false,
      saveNewContactInfo: false,
      //notificationEmails: "", showNotificationEmailField: false,
    },

    rules: {
      required: (value) => !!value || "Required.",
      // email: (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( v ) || "Enter a valid email",
    },

    columns: [
      {
        field: "priorityName",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: () => {
          return "mdi-box-shadow";
        },
        iconColor: (value) => {
          return priorityOptions.find((p) => p.name === value).color;
        },
      },
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: statusIcon,
        iconColor: statusIconColor,
      },
      //{ label: "Status", field: "statusName", visible: true, filterValues: [], filterValue: null, selectedFilterOperation: null, },
      {
        label: "Ticket Number",
        field: "displayID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        link: "HelpDeskRequestView",
        template: "link-cell-template",
      },
      {
        label: "Subject",
        field: "subject",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-300",
      },
      {
        label: "Requester Email",
        field: "requesterEmailID",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Created At",
        field: "createdAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Technician",
        field: "technicianName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Due By",
        field: "dueByAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Sync Time",
        field: "lastSyncTime",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Source",
        field: "source",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "requesterName",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "User",
        field: "username",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Site",
        field: "requestSiteName",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Department",
        field: "requesterDepartmentName",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // { label: "Technician Email", field: "technicianEmailID", visible: true, filterValues: [], filterValue: null, selectedFilterOperation: null, },
    ],
  }),

  async created() {
    if (this.$route.query.showClosed) {
      this.includeClosed = true;
    }

    this.actions.push({
      text: "New Ticket",
      action: this.openNewTicket,
    });

    await this.getManageengineUserInfo();

    if (!this.manageengineUserInfo) {
      this.unmappedUserHandle();
    }
    if (this.$route.query.openNewTicket) {
      this.openNewTicket();
    }
  },

  watch: {
    "newTicket.phone"() {
      this.checkContactInfoChanged();
    },
    "newTicket.phoneMapped"() {
      this.checkContactInfoChanged();
    },
    "newTicket.ext"() {
      this.checkContactInfoChanged();
    },
    "newTicket.room"() {
      this.checkContactInfoChanged();
    },
  },

  methods: {
    checkContactInfoChanged() {
      this.newTicket.hasContactInfoChanged =
        this.newTicket.phone !== this.manageengineUserInfo[0].phone ||
        this.newTicket.phoneMapped !==
          this.manageengineUserInfo[0].phoneMapped ||
        this.newTicket.ext !== this.manageengineUserInfo[0].extension ||
        this.newTicket.room !== this.manageengineUserInfo[0].room;
    },

    async beforeSetupGrid() {
      localStorage.getItem("include-closed") == "true"
        ? (this.includeClosed = true)
        : false;
      this.includeClosed
        ? (this.filterForStatus = ["Open", "On Hold", "Closed"])
        : (this.filterForStatus = ["Open", "On Hold"]);
      this.url = `manageengine?statuses=${
        this.filterForStatus
      }&technicians&filterForUserId&filterTicketsNeedingAttention=false`;

      this.actions.push({
        text: "Show Closed",
        type: "switch",
        align: "left",
        value: this.includeClosed,
        action: this.onShowClosedChanged,
      });
    },

    onShowClosedChanged(value) {
      localStorage.setItem("include-closed", value);
      this.includeClosed = value;

      this.includeClosed
        ? (this.filterForStatus = ["Open", "On Hold", "Closed"])
        : (this.filterForStatus = ["Open", "On Hold"]);

      this.url = `manageengine?statuses=${
        this.filterForStatus
      }&technicians&filterForUserId&filterTicketsNeedingAttention=false`;

      this.$refs.grid.reloadDataSource(this.url);
    },

    async openNewTicket() {
      if (!this.manageengineUserInfo) {
        this.unmappedUserHandle();
        return;
      }
      this.newTicket.phone = this.manageengineUserInfo[0].phone;
      this.newTicket.phoneMapped = this.manageengineUserInfo[0].phoneMapped;
      this.newTicket.ext = this.manageengineUserInfo[0].extension;
      this.newTicket.room = this.manageengineUserInfo[0].room;

      this.newTicketDialog = true;
      this.fileUploadList = [];
    },

    async getManageengineUserInfo() {
      try {
        const response = await this.$http.get(
          "api/manageengineUSers/getManageengineUserInfo"
        );
        this.manageengineUserInfo = response.data;
      } catch (error) {
        console.error(error);
      }
    },

    async saveNewTicket() {
      if (this.newTicket.saveNewContactInfo) {
        this.saveNewContactInfoChanged();
      }
      const filesId = [];
      for (var i = 0; i < this.fileUploadList.length; i++) {
        filesId.push(this.fileUploadList[i].file_id);
      }
      if (!this.$refs.form.validate(true)) {
        return;
      }

      try {
        this.processing = true;
        this.cancelBtnAbility = true;
        const hasUserInfo =
          this.newTicket.phone && this.newTicket.phone.trim() ||
          this.newTicket.room && this.newTicket.room.trim() ||
          this.newTicket.ext && this.newTicket.ext.trim();

        const userInfo = [
          this.newTicket.phone && this.newTicket.phone.trim()
            ? `<b>Phone</b>: ${this.newTicket.phone}<br>`
            : "",
          this.newTicket.room && this.newTicket.room.trim()
            ? `<b>Room</b>: ${this.newTicket.room.trim()}<br>`
            : "",
          this.newTicket.ext && this.newTicket.ext.trim()
            ? `<b>Ext</b>: ${this.newTicket.ext.trim()}`
            : "",
        ]
          .filter(Boolean)
          .join("");

        const desc = `${this.newTicket.description}${
          hasUserInfo ? `<br><br><br><br>${userInfo}` : ""
        }`;
        const description = linkifyPlainUrlsInHtml(
          desc.replace(/  /g, "&nbsp;").replace(/\n/g, "<br>")
        );

        const response = await this.$http.post(
          "api/Manageengine/ManageenginePost",
          {
            UserId: this.manageengineUserInfo[0].id,
            Subject: this.newTicket.subject,
            Description: description,
            Priority: this.priorityOptions.find(p => p.text == this.newTicket.priority).name,
            Category: this.newTicket.category
              ? this.newTicket.category
              : "Untitled",
            Attachments: filesId[0] ? JSON.stringify(filesId) : "",
            // NotificationEmails: this.newTicket.notificationEmails,
          }
        );

        this.processing = false;
        this.cancelBtnAbility = false;

        this.$notify({
          text: "Ticket Created",
          group: "notification",
          type: "success",
        });
        this.reset();
        this.$refs.grid.reloadGrid();
        this.$router.push({
          name: "HelpDeskRequestView",
          params: { id: response.request.display_id },
        });
      } catch (e) {
        this.processing = false;
        this.cancelBtnAbility = false;
        alert(
          `We're sorry, but your ticket could not be submitted. Please contact support at extension #12340 and provide your username: ${
            this.$store.state.authentication.user
          }`
        );
      }
    },

    reset() {
      this.newTicketDialog = false;
      this.newTicket = {
        subject: "",
        description: "",
        category: "",
        priority: "Normal",
        phone: "",
        room: "",
        ext: "",
        phoneMapped: "",
        hasContactInfoChanged: false,
        saveNewContactInfo: false,
      };
      // this.newTicket.notificationEmails = ""; this.newTicket.showNotificationEmailField = false;
      this.removeAllUploadImg();
      this.$refs.form.resetValidation(true);
    },

    pickFile() {
      this.$refs.files.click();
    },

    async onFilePicked(e) {
      this.uploading = true;
      this.sendBtnDisability = true;
      const files = e.target.files;

      if (!files) return;
      try {
        for (var i = 0; i < files.length; i++) {
          var formData = new FormData();
          formData.append("file", files[i]);
          const response = await this.$http.post(
            "api/Manageengine/ManageengineUpload",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          this.fileUploadList.push(response.files[0]);
        }
        this.uploading = false;
        this.sendBtnDisability = false;
        this.$refs.files.value = null;
      } catch (e) {
        this.uploading = false;
      }
    },

    removeUploadImg(index) {
      this.fileUploadList.splice(index, 1);
    },

    removeAllUploadImg() {
      this.fileUploadList = [];
      this.uploading = false;
      this.sendBtnDisability = false;
      this.$refs.files.value = null;
    },

    truncateText(text, count = 25) {
      return truncate(text, count);
    },

    reloadGrid() {
      this.$refs.grid.reloadGrid();
    },

    unmappedUserHandle() {
      this.unmappedUserPhone = "";
      this.unmappedUserDialog = true;
    },

    async submitUnmappedUserTicket() {
      try {
        await this.$http.post("api/Manageengine/ManageenginePost", {
          UserId: "24078000030239745", // defaultuser@utaw.org
          Subject: `${
            this.$store.state.authentication.user
          } cannot send request via the portal`,
          Description: `user ${this.$store.state.authentication.user} phone: ${
            this.unmappedUserPhone
          }`,
          Priority: "2 Normal",
          Category: "Software",
        });
        this.$notify({
          text: "Ticket Sent, we will contact you.",
          group: "notification",
          type: "success",
        });
      } catch (error) {
        console.error(error);
      }
      this.unmappedUserDialog = false;
    },

    async loadDisplayIdsList() {
      this.displayIdsList = [];
      const data = this.$refs.grid.grid.getDataSource().items();
      data.forEach((row) => {
        this.displayIdsList.push(row.displayID);
      });
    },

    async onRowClicked(row) {
      await this.loadDisplayIdsList();
      this.$router.push({
        name: "HelpDeskRequestView",
        params: { id: row.displayID },
        query: this.displayIdsList,
      });
    },

    async saveNewContactInfoChanged() {
      const changes = [];
      if (this.newTicket.phone !== this.manageengineUserInfo[0].phone)
        changes.push(`<b>phone</b>: ${this.newTicket.phone}`);
      if (
        this.newTicket.phoneMapped !== this.manageengineUserInfo[0].phoneMapped
      )
        changes.push(`<b>phone 2</b>: ${this.newTicket.phoneMapped}`);
      if (this.newTicket.ext !== this.manageengineUserInfo[0].extension)
        changes.push(`<b>extension</b>: ${this.newTicket.ext}`);
      if (this.newTicket.room !== this.manageengineUserInfo[0].room)
        changes.push(`<b>room number</b>: ${this.newTicket.room}`);

      const changedInfo = changes.join(", ");

      if (!changedInfo) return;

      try {
        await this.$http.post("api/Manageengine/ManageenginePost", {
          UserId: this.manageengineUserInfo[0].id,
          Subject: `User ${
            this.$store.state.authentication.user
          } Details Update`,
          Description: `We have received your request to update these bolow. We checking the information. <br> <br> Changes: <br> ${changedInfo}`,
          Priority: "2 Normal",
          Category: "Software",
          Technician: "24078000024106094", //Mordechai Danziger
        });
      } catch (error) {
        console.error(error);
      }
    },
    onCellPrepared(e) {
      if (e && e.values && e.row.key.userHasRead != true) {
        e.cellElement.style.setProperty(
          "font-weight",
          "bold",
          "important"
        );
      }
    },
  },
};
</script>
<style scoped>
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1.5s infinite;
}
</style>
